import { Link } from 'react-router-dom';
import { categories, completedComics, newComics } from '@/mocks/comics';

export default function CategoryFeature() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
            分类专题
            <span className="text-accent-600"> · 发现你的最爱</span>
          </h2>
          <p className="text-foreground-500 mt-3 text-sm md:text-base">
            韩漫在线观看 · 漫画免费下拉式阅读 · 完整阅读体验
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-4 max-w-7xl mx-auto">
          <div className="lg:w-1/2">
            <Link
              to="/category/love"
              className="block relative rounded-2xl overflow-hidden aspect-[4/5] group cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Romantic%20Korean%20manga%20scene%20soft%20warm%20lighting%20couple%20in%20elegant%20setting%20beautiful%20detailed%20illustration%20with%20dreamy%20pink%20and%20cream%20tones%20artistic%20manga%20art&width=900&height=1125&seq=feature-big-2026&orientation=portrait"
                alt="本周强推韩漫"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-white text-xs font-medium mb-2 whitespace-nowrap">
                  本周强推
                </span>
                <h3 className="font-heading text-2xl font-bold text-white">恋爱韩漫精选</h3>
                <p className="text-white/70 text-sm mt-1">甜蜜浪漫的韩国恋爱漫画合集</p>
              </div>
            </Link>
          </div>

          <div className="lg:w-1/2 flex flex-col gap-4">
            <Link
              to="/category/love"
              className="block relative rounded-2xl overflow-hidden aspect-[2/1] group cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Collection%20of%20completed%20Korean%20manga%20series%20elegant%20artistic%20arrangement%20soft%20sage%20green%20tones%20sophisticated%20comic%20covers%20compilation%20clean%20professional%20layout&width=900&height=450&seq=feature-completed&orientation=landscape"
                alt="完结精选韩漫"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-600 text-white text-xs font-medium mb-2 whitespace-nowrap">
                  完结精选
                </span>
                <h3 className="font-heading text-xl font-bold text-white">
                  已完结韩漫 · {completedComics.length}部全本可读
                </h3>
              </div>
            </Link>

            <Link
              to="/category/action"
              className="block relative rounded-2xl overflow-hidden aspect-[2/1] group cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=New%20released%20Korean%20action%20manga%20series%20dynamic%20composition%20soft%20rose%20pink%20tones%20exciting%20manga%20covers%20artistic%20arrangement%20clean%20layout&width=900&height=450&seq=feature-new&orientation=landscape"
                alt="本周新番韩漫"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-secondary-500 text-white text-xs font-medium mb-2 whitespace-nowrap">
                  本周新番
                </span>
                <h3 className="font-heading text-xl font-bold text-white">
                  最新上架 · {newComics.length}部新作登场
                </h3>
              </div>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 mt-10 max-w-7xl mx-auto">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-3 p-5 rounded-2xl bg-background-100 hover:bg-background-200/80 transition-colors cursor-pointer group"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-xl text-accent-600 w-5 h-5 flex items-center justify-center`} />
              </div>
              <span className="font-medium text-sm text-foreground-800 whitespace-nowrap">{cat.name}</span>
              <span className="text-xs text-foreground-500">{cat.count}部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}